import api from './api.js'

// 消息列表
export function getConsultInfoList(params){
    return api.get('/resource-message/api/v1/consult/query',params);
}

//明细
export function findConsultInfo(uuid) {
    return api.get(`/resource-message/api/v1/consult/${uuid}`);
}



// WEBPACK FOOTER //
// ./src/utils/consultInfo.js